import React, { useState } from 'react';

import { makeStyles, useMediaQuery, Grid, Typography } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';

import CustomAccordion from '../common/CustomAccordion';

const useStyles = makeStyles((theme) => {
  return {
    mobileContainer: {
      borderBottom: '2px solid #E7E7E7',
      marginBottom: '20px',
      paddingBottom: '15px',
    },
    titleContainer: {
      marginBottom: '0px',
      [theme.breakpoints.up('lg')]: {
        marginBottom: '20px',
      },
    },
  };
});

export default ({ video, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const classes = useStyles();
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('lg'));

  const handleChangeAccordion = (_event, exp) => setIsOpen(exp);

  const renderCustomIcon = () => <ExpandMore style={{ color: isOpen && '#2AAAE2' }} />;

  const renderTitle = () => (
    <Grid container className={classes.titleContainer}>
      <Grid item xs={12}>
        <Typography align="left" className="secondary-header">
          {video?.title}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography align="left" style={{ color: '#999999', fontSize: '14px', fontWeight: 700, textTransform: 'uppercase' }}>
          {video?.type}
        </Typography>
      </Grid>
    </Grid>
  );

  let renderElement = () => (
    <>
      {renderTitle()}
      {children}
    </>
  );

  if (!isDesktop) {
    renderElement = () => (
      <div className={classes.mobileContainer}>
        <CustomAccordion onChange={handleChangeAccordion} expanded={isOpen} customIcon={renderCustomIcon()} title={renderTitle()}>
          <div style={{ marginTop: '15px' }}>{children}</div>
        </CustomAccordion>
      </div>
    );
  }

  return renderElement();
};
